<schedules-remove-asset-success
  *ngIf="removeAssetStatus === 'successfull'"
  (navigateReferFriend)="referFriend()"
  (navigateClose)="close()"
></schedules-remove-asset-success>
<schedules-remove-asset-fail *ngIf="removeAssetStatus === 'failed'" (navigateClose)="close()"></schedules-remove-asset-fail>

<!-- TODO ALL OTHER POPUPS SHOULD BE REPLACED BY THIS GENERIC POPUP -->
<popup-dialog id="schedules.remove.asset.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
